module.exports = "pegasus_template/assets/theme2/l_w.png";